import { AutogenLayoutFuelReimbursementRate } from "./autogen/AutogenLayoutFuelReimbursementRate";
import {
    DataSourceMode, LookupModelSearchEvent, TableRow, TableRowDisplayEvent, Textbox, ValidationResult
} from "@mcleod/components";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";
import { ModelRow } from "@mcleod/core";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "fuel_reimbursement",
    screenName: "Fuel Reimbursement Rate",
    navigateToUrl: "lme/settlement/FuelReimbursementRate?mode=update&key="
};

export class FuelReimbursementRate extends AutogenLayoutFuelReimbursementRate {
    async onLoad(): Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
    }

    tableFuelPayRateOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        this.addRowValidationListeners(tableRow);
    }

    addRowValidationListeners(tableRow: TableRow) {
        const textboxBeginningDate = tableRow.findComponentById("textboxBeginningDate") as Textbox;
        if (textboxBeginningDate) {
            textboxBeginningDate.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                if (mode === DataSourceMode.SEARCH) {
                    return null;
                }
                const result: ValidationResult = {
                    component: textboxBeginningDate,
                    isValid: true
                }
                return this.validateDates(tableRow, result);
            };
        }
    }

    validateDates(tableRow: TableRow, result: ValidationResult): ValidationResult {
        const modelRow = tableRow.data as ModelRow;
        const textboxBeginningDate = tableRow.findComponentById("textboxBeginningDate") as Textbox;
        const textboxEndDate = tableRow.findComponentById("textboxEndDate") as Textbox;

        if (textboxBeginningDate && textboxEndDate) {
            const beginningDate = modelRow.getDate("beginning_date");
            const endingDate = modelRow.getDate("end_date");
            if (beginningDate && endingDate && beginningDate > endingDate) {
                result.isValid = false;
                result.validationMessage = "Beginning Date cannot be after Ending Date.";
            }
        }
        return result;
    }

    textboxDeductCodeBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.isactive = "Y";
    }
}
